import React from 'react';
import { DisclaimersContainer, DisclaimersMessage } from './styles';

export default function Disclaimers({ translations }) {
  // Fallbacks if translations are missing
  const message =
    translations?.disclaimersSection?.message ||
    '*Tax is estimated and may be adjusted at final invoicing based on current rates in your service location.';

  return (
    <DisclaimersContainer>
      <DisclaimersMessage>{message}</DisclaimersMessage>
    </DisclaimersContainer>
  );
}